export const LAYOUT_OPTIONS = {
  LIST: "LIST",
  TABLE: "TABLE",
  GRID: "GRID",
};
